module.exports = __webpack_public_path__ + "static/media/secured-payments.a35c80b7.jpg";